import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetTagsValuesRequest,
  GetTagsValuesResponse,
} from "../../models/TagValue.model";

const API_BASE_URL = environment.apiUrl;

export const GetTagsValues = createAsyncThunk<
  GetTagsValuesResponse,
  GetTagsValuesRequest,
  { rejectValue: string }
>("tagsValue/GetTagsValues", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}TagValue/GetTagsValues`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetTagsValuesResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch base tables");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});
